jQuery( document ).ready( function( $ ) {

    /**
     * Brochure Downloads
     */
    $('.ga-brochure-download').on('click', (e) => {

        let propertyName = $(e.target).data('property-name');

        gaEvent( 'Brochure Downloads', 'Brochure Download', propertyName );

    });

    /**
     * Phone Call + Email Click (temp)
     */
    $('.ga-phone-call').on('click', (e) => {

        let propertyName = $(e.target).data('property-name');

        gaEvent( 'Phone Calls', 'Broker Phone Call', propertyName );

    });

    $('.ga-email').on('click', (e) => {

        let propertyName = $(e.target).data('property-name');

        gaEvent( 'Emails', 'Broker Email Link', propertyName );

    });


    /**
     * Contact Submissions
     */
    let submittedCheck = $('#commercial-real-estate-broker-contact-submitted');
    if(submittedCheck.length) {
        let propertyName = submittedCheck.val();

        gaEvent( 'Contact Submissions', 'Contact Form Submission', propertyName );
    }

});

function gaEvent( category, action, label ) {
    if ( typeof ga !== 'undefined' ) {
        ga( 'send', 'event', category, action, label );
    }
    // ga4 event
    if ( typeof gtag !== 'undefined' ) {
        gtag( 'event', action, {
            'event_category': category,
            'event_label': label
        } );
    }
}
